import type { Meta, StoryObj } from "@storybook/react";

import { ReplayAnimationDecorator } from "@/__stories__/ReplayAnimationDecorator";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import type { FadeInUpViewProps } from "@/ui/layout/animated/FadeInUpView";
import {
  FadeInUpDelay,
  FadeInUpDelayValues,
  FadeInUpView,
} from "@/ui/layout/animated/FadeInUpView";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<FadeInUpViewProps> = {
  title: "Layout/Animated/Fade In Up View",
  component: FadeInUpView,
  argTypes: {
    delay: {
      control: "select",
      options: FadeInUpDelayValues,
    },
  },
  args: {
    delay: FadeInUpDelay.None,
  },
};

type Story = StoryObj<FadeInUpViewProps>;

const Default: Story = {
  render: (args) => {
    return (
      <ReplayAnimationDecorator>
        <FadeInUpView delay={args.delay}>
          <Box
            backgroundColor={ColorToken.Primary10}
            borderRadius={12}
            padding={16}
          >
            <Text testID="story-text" variant="body">
              This content fades in and slides up
            </Text>
          </Box>
        </FadeInUpView>
      </ReplayAnimationDecorator>
    );
  },
};

const WithDelay: Story = {
  render: () => {
    const values = ["First", "Second", "Third"];
    return (
      <ReplayAnimationDecorator>
        {/* eslint-disable-next-line max-params -- map callback requires index for delay */}
        {values.map((label, index) => {
          return (
            <FadeInUpView delay={index * FadeInUpDelay.Default} key={label}>
              <Box
                backgroundColor={ColorToken.Primary10}
                borderRadius={12}
                padding={16}
              >
                <Text testID={`story-${label}`} variant="body">
                  {label} item (delay: {index * FadeInUpDelay.Default}ms)
                </Text>
              </Box>
            </FadeInUpView>
          );
        })}
      </ReplayAnimationDecorator>
    );
  },
};

export { Default, WithDelay };
export default StoryMeta;
